import { render, staticRenderFns } from "./WorkplaceTransactionDetail.vue?vue&type=template&id=c14ce448"
import script from "./WorkplaceTransactionDetail.vue?vue&type=script&lang=ts"
export * from "./WorkplaceTransactionDetail.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports